import * as THREE from "three";

function isLine(object: THREE.Object3D): object is THREE.Line {
	return object instanceof THREE.Line;
}

export { isLine };
